import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';

interface PriorityBarChartProps {
  data: {
    [key: string]: {
      Top: number;
      High: number;
      Medium: number;
      Low: number;
      Non: number;
    };
  };
}

const PriorityBarChart: React.FC<PriorityBarChartProps> = ({ data }) => {
  const chartData = Object.entries(data).map(([bu, priorities]) => ({
    name: bu,
    Top: priorities.Top,
    High: priorities.High,
    Medium: priorities.Medium,
    Low: priorities.Low,
    Non: priorities.Non
  }));

  const colors = {
    Top: '#dc2626',
    High: '#a855f7',
    Medium: '#2563eb',
    Low: '#06b6d4',
    Non: '#10b981'
  };

  return (
    <div className="chart-container bar-chart-container">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="Top" fill={colors.Top} />
          <Bar dataKey="High" fill={colors.High} />
          <Bar dataKey="Medium" fill={colors.Medium} />
          <Bar dataKey="Low" fill={colors.Low} />
          <Bar dataKey="Non" fill={colors.Non} />
        </BarChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        {Object.entries(colors).map(([key, color]) => (
          <div key={key} className="legend-item">
            <div 
              className="legend-color" 
              style={{ backgroundColor: color }}
            ></div>
            <span className="legend-label">{key}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PriorityBarChart;